import { connect } from "react-redux";
import Anlagenpass from "./Anlagenpass";
import { makeUndefinedCompressor, compressorIndexFromLocation } 
	from "../model/Kompressor";

const getCompressor = state => {
	let index = compressorIndexFromLocation(state.router.location.pathname);
	let compressor = state.ablauf.compressors[index] || makeUndefinedCompressor(index);
	return compressor;
};

export default connect(state => ({
	compressor: getCompressor(state)
}))(Anlagenpass);
